import { render, staticRenderFns } from "./suppliersBalance.vue?vue&type=template&id=3accdf84&"
import script from "./suppliersBalance.vue?vue&type=script&lang=ts&"
export * from "./suppliersBalance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports